<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card flat>
        <v-layout row wrap>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">Rapor Detay</v-toolbar-title>
          </v-toolbar>
          <v-layout row="" wrap>
            <v-flex xs12 sm12 md12>
               <a target="_blank" v-bind:href="'#/rapor/rapordetaydestek'">
              <v-card>
                <v-flex pa-2 xs12 sm12 md12>
                  <v-list two-line>
                    <template >
                      <v-hover v-slot:default="{ hover }">
                        <v-card :elevation="hover ? 12 : 1">
                          <v-layout ma-2 row wrap >
                            <v-flex xs6 sm4 md2>
                              <v-layout align-start="" justify-start fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content style="'overflow=inherit';">
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold caption ">
                                          Sorun Tip : 
                                        </div>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm4 md5>
                              <v-layout align-start="" justify-start fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content style="'overflow=inherit';">
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold  caption">
                                          Sorun:
                                        </div>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm3 md2>
                              <v-layout align-start="" justify-start fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content style="'overflow=inherit';">
                                      <v-list-tile-sub-title>
                                        <div class="font-weight-bold caption ">
                                          Arayan:
                                        </div>
                                      </v-list-tile-sub-title>
                                       <v-list-tile-sub-title>
                                        <div class="font-weight-bold caption ">
                                          Çözecek:
                                        </div>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                            <v-flex xs10 sm8 md2>
                              <v-layout align-start="" justify-start fill-height>
                                <v-card flat="">
                                  <v-list-tile>
                                    <v-list-tile-content style="'overflow=inherit';">
                                         <v-list-tile-sub-title>
                                        <v-layout>
                                          <div class="font-weight-bold caption">
                                            Alış Tarihi:
                                          </div>
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                      <v-list-tile-sub-title>
                                        <v-layout>
                                          <div class="font-weight-bold caption">
                                            Toplam Süre:
                                          </div>
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-card>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-spacer ></v-spacer>
                        </v-card>
                      </v-hover>
                    </template>
                  </v-list>
                </v-flex>
              </v-card>
               </a>
            </v-flex>
          </v-layout>
                <v-container>
            <v-layout justify-center="">
              <template>
                <div class="text-xs-center">
                  <v-container>
                    <v-layout justify-center>
                      <v-flex xs8>
                        <v-pagination ></v-pagination>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </template>
            </v-layout>
          </v-container>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>
<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  export default {
    data() {
      return {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        loading: false,
        load1: '',
        search: '',
        itemsSorunTip:[],
        musteriitems:[],
        Raporlar:{
            AlisTarihiBas:null,
            AlisTarihiBit:null,
        }
      }
    },
    beforeMount: beforeMount,
    components: {
    },
    watch: {
    },
    methods: {
    },
  }
  function beforeMount() {
  }

</script>

<style>
</style>